import { Button, Col, Divider, Modal, Row, Typography, message } from "antd";
import lodash from "lodash";
import React, { useEffect, useState } from "react";
import { labelDateSelector } from "../../../store/var/var.selector";
import {
  deleteIncomeDetail,
  updateIncomeDetail,
} from "../../../store/income_detail/income_detail.action";
import { useDispatch, useSelector } from "react-redux";
import { detailBranchSelector } from "../../../store/branch/branch.selector";
import {
  snapJobDetailById,
  unSnapJobDetail,
  updateJobById,
  updateJobByStaff,
} from "../../../store/job/job.action";
import { jobDetailSelector } from "../../../store/job/job.selector";

import IncomeStaffJobId from "./component/income_staff_jobId";
import IncomeStaffTime from "./component/income_staff_time";
import IncomeStaffTotal from "./component/income_staff_total";
import IncomeStaffRemaining from "./component/income_staff_remaining";
import IncomeStaffInput from "./component/income_staff_input";
import IncomeStaffIncomeList from "./component/income_staff_income_list";
import IncomeStaffServiceList from "./component/income_staff_service_list";
import { staffListSelector } from "../../../store/staff/staff.selector";
import moment from "moment";

const { Text } = Typography;
const DialogIncomeStaffEdit = (props) => {
  // -------------------------- VAR --------------------------
  const { open, setOpen, data } = props;
  // console.log({ data });
  // -------------------------- STATE --------------------------
  const [value, setValue] = useState(null);
  const [max, setMax] = useState(0);
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const date = useSelector(labelDateSelector);
  const userList = useSelector(staffListSelector);
  const branch = useSelector(detailBranchSelector);
  const branchId = branch ? branch?.id : "";
  const userId = data?.userId;
  const record = useSelector(jobDetailSelector);
  // console.log({ userList });
  // -------------------------- FUNCTION --------------------------
  const handleCancel = () => {
    setOpen(false);
  };

  const handleUpdate = () => {
    setLoading(true);
    const jobId = record?.id || "";

    // update income in income details collection
    const incomeUpdate = {
      id: data?.id,
      branch: branchId,
      userId,
      value,
      jobId,
      date: date,
    };
    const incomePromise = new Promise((resolve, reject) =>
      dispatch(
        updateIncomeDetail({ data: incomeUpdate }, (res) => {
          if (res?.status === 200) {
            message.success("Updated successfully");
            resolve(true);
          } else {
            message.error(res?.data);
            reject(true);
          }
        })
      )
    );

    // update income in job collection
    // console.log({ record });
    const update = {
      userId,
      value,
    };
    const jobPromise = new Promise((resolve, reject) => {
      if (jobId) {
        dispatch(
          updateJobByStaff(
            {
              id: jobId,
              update,
            },
            (res) => {
              if (res?.status === 200) {
                //   message.success("Added successfully");
                resolve(true);
              } else {
                message.error(res?.data);
                reject(true);
              }
            }
          )
        );
      } else {
        resolve(true);
      }
    });
    // sau khi đã record data thành công.
    Promise.all([incomePromise, jobPromise]).then(() => {
      setLoading(false);
      setOpen(false);
    });
  };

  const handeDelete = () => {
    setLoading(true);
    const jobId = record?.id || "";

    // delete income in income details collection
    const incomeDelete = {
      id: data?.id,
    };
    const incomePromise = new Promise((resolve, reject) =>
      dispatch(
        deleteIncomeDetail({ data: incomeDelete }, (res) => {
          if (res?.status === 200) {
            message.success("Deleted successfully");
            resolve(true);
          } else {
            message.error(res?.data);
            reject(true);
          }
        })
      )
    );

    // update  income in job collection
    // console.log({ record });
    const update = {
      userId,
      value: null,
    };
    const jobPromise = new Promise((resolve, reject) => {
      if (jobId) {
        dispatch(
          updateJobByStaff(
            {
              id: jobId,
              update,
            },
            (res) => {
              if (res?.status === 200) {
                //   message.success("Added successfully");
                resolve(true);
              } else {
                message.error(res?.data);
                reject(true);
              }
            }
          )
        );
      } else {
        resolve(true);
      }
    });
    // sau khi đã record data thành công.
    Promise.all([incomePromise, jobPromise]).then(() => {
      // unlock job after delete income
      const update = {
        lockAt: moment().toDate(),
      };
      const id = record?.id;
      if (id) {
        dispatch(
          updateJobById({ id, update }, (res) => {
            if (res.status === 200) {
              console.log("unlocked");
              setLoading(false);
              setOpen(false);
            } else {
              //
            }
          })
        );
      } else {
        setLoading(false);
        setOpen(false);
      }
    });
  };

  const handleAfterClose = () => {
    setMax(null);
    const update = {
      lockAt: moment().toDate(),
    };
    const id = record?.id;
    // console.log({record, id})
    if (id) {
      dispatch(
        updateJobById({ id, update }, (res) => {
          if (res.status === 200) {
            console.log("unlocked");
          } else {
            //
          }
        })
      );
    }
  };
  // -------------------------- EFFECT --------------------------
  // get Job data when dialog open and data change
  useEffect(() => {
    if (open && data) {
      // khởi tạo giá trị income theo data mỗi lần mở edit dialog
      const value = data?.value;
      setValue(value);

      // get record job
      if (branch) {
        const id = data?.jobId || "";
        dispatch(
          snapJobDetailById({ id }, (res) => {
            if (res.status === 200) {
              // console.log("success")
            } else {
              // console.log("error");
            }
          })
        );
        return () => dispatch(unSnapJobDetail());
      }
    }
  }, [dispatch, open, data]);

  // set Max
  useEffect(() => {
    if (record) {
      const spent = lodash.sumBy(record?.staffs, (staff) => staff?.value);
      const remainingValue = record?.subtotal - spent + data?.value;
      setMax(remainingValue);
    } else {
      setMax(null);
    }
  }, [record]);

  // auto close modal after 1 minute
  useEffect(() => {
    if (open) {
      const timer = setTimeout(() => {
        setOpen(false);
        message.warning("Exceeded waiting time");
      }, 60000); // Đóng modal sau 1 phút

      // Hủy bỏ hẹn giờ khi component unmount
      return () => clearTimeout(timer);
    }
  }, [open]);

  // -------------------------- RENDER --------------------------
  const renderButtonGroup = () => {
    return (
      <Col span={24}>
        <Row gutter={[10, 10]}>
          <Col span={12}>
            <Button
              type="primary"
              size="large"
              block
              onClick={handeDelete}
              loading={loading}
              danger
            >
              Delete
            </Button>
          </Col>
          <Col span={12}>
            <Button
              type="primary"
              size="large"
              block
              onClick={handleUpdate}
              loading={loading}
            >
              Update
            </Button>
          </Col>
        </Row>
      </Col>
    );
  };

  // -------------------------- MAIN --------------------------
  const currentUser = userList?.find((user) => user?.id === userId);
  const title = `Input income by ${currentUser?.firstName} ${currentUser?.lastName} `;
  return (
    <Modal
      title={title}
      open={open}
      onCancel={handleCancel}
      footer={false}
      afterClose={handleAfterClose}
    >
      <Row gutter={[20, 20]}>
        <IncomeStaffJobId record={record} />
        <IncomeStaffTime record={record} />
        <IncomeStaffServiceList record={record} />
        <IncomeStaffTotal record={record} />
        <IncomeStaffRemaining record={record} max={max} />
        <IncomeStaffInput max={max} value={value} setValue={setValue} />
        <Divider dashed style={{ marginTop: 5, marginBottom: 5 }} />
        <IncomeStaffIncomeList record={record} userList={userList} />
        {renderButtonGroup()}
      </Row>
    </Modal>
  );
};
export default DialogIncomeStaffEdit;
